import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Message as MessageType } from '../types/Message';
import { NoteDirection } from '../types/NoteDirection';
import { useAppContext } from '../../../../AppContext';

type Props = {
  message: MessageType;
};

const Message = (props: Props) => {
  const context = useAppContext();
  const isReceived = props.message.noteDirection === NoteDirection.Received;

  const getReceivedBgColor = () => {
    const messagesReceivedModule = context.styles['module:messages:received'];
    if (messagesReceivedModule?.backgroundColor) return messagesReceivedModule.backgroundColor;
    return '#ebf5f4';
  };

  const getReceivedTextColor = () => {
    const messageModule = context.styles['module:messages'];
    const messagesReceivedModule = context.styles['module:messages:received'];
    if (messagesReceivedModule?.textColor) return messagesReceivedModule.textColor;
    if (messageModule?.textColor) return messageModule.textColor;
    return undefined;
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Paper
        elevation={1}
        sx={{
          px: 2,
          py: 1.5,
          width: '90%',
          bgcolor: isReceived ? getReceivedBgColor() : '#fff',
          color: isReceived ? getReceivedTextColor() : undefined,
          ml: isReceived ? 0 : 'auto',
          mr: isReceived ? 'auto' : 0,
          borderRadius: 1,
          whiteSpace: 'pre-line',
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
          {props.message.noteCreatorName}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {props.message.noteText}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'right' }}>
          {props.message.noteSendDateFormatted}
        </Typography>
      </Paper>
    </Box>
  );
};

export default Message;